/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`
export default class ImgIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" css={Color}>
        <g id="그룹_5432" data-name="그룹 5432" transform="translate(5329 -337)">
          <rect id="사각형_5535" data-name="사각형 5535" width="20" height="20" transform="translate(-5329 337)" fill="#0b0c0f" opacity="0"/>
          <g id="그룹_5428" data-name="그룹 5428">
            <path id="패스_5023" data-name="패스 5023" d="M996.219,1297.75h-12a3.005,3.005,0,0,0-3,3v11.092a3.006,3.006,0,0,0,3,3h12.168a2.756,2.756,0,0,0,2.832-3.039v-11.057A3.005,3.005,0,0,0,996.219,1297.75Zm-8.763,8.078,2.739,2.8-.016.017,4.693,4.809H984.219a1.618,1.618,0,0,1-1.616-1.617v-1.259l3.9-4.759A.707.707,0,0,1,987.456,1305.829Zm4.955.373-1.28,1.4-2.687-2.747a2.111,2.111,0,0,0-2.952.017l-2.889,3.52v-7.64a1.618,1.618,0,0,1,1.616-1.617h12a1.618,1.618,0,0,1,1.615,1.617v8.383l-2.466-2.928-.013-.014a2.076,2.076,0,0,0-2.945.007Zm.987.974a.73.73,0,0,1,.942-.038l3.494,4.15v.545l0,.055a1.745,1.745,0,0,1-.025.251c-.006.034-.016.067-.034.128s-.029.105-.047.154-.038.087-.059.132-.045.086-.069.126-.053.084-.081.123-.056.07-.094.114-.064.073-.1.106l-.074.061a1.6,1.6,0,0,1-.484.276L992.1,1308.6Z" transform="translate(-6309.219 -959.75)" fill="#141414"/>
            <path id="패스_5024" data-name="패스 5024" d="M997.5,1302.433a1.974,1.974,0,1,0-1.974,1.974A1.976,1.976,0,0,0,997.5,1302.433Zm-1.316,0a.658.658,0,1,1-.658-.658A.659.659,0,0,1,996.186,1302.433Z" transform="translate(-6309.839 -959.681)" fill="#141414"/>
          </g>
        </g>
      </svg>
    )
  }
}
